// Must run before frappe-ui network code
import './frappeFetchPatch'
import './frappeXhrPatch'
import { initThemeFromStorage } from './composables/useTheme'
initThemeFromStorage()
import './style.css'
import { createApp } from 'vue'
import { FrappeUI } from 'frappe-ui'
import { io } from 'socket.io-client'
import router from './router'
import App from './App.vue'
import { resolveSiteName, socketPath } from './config'
import { installQuery } from './composables/useQueryClient'
import { queryClient } from './composables/useQueryClient'
import { installChunkReload } from './utils/chunkReload'

const app = createApp(App)

// A stale tab after a deploy: reload once to fetch the new index (see utils/chunkReload.js).
installChunkReload({
  target: window,
  storage: {
    getItem: (k) => window.sessionStorage.getItem(k),
    setItem: (k, v) => window.sessionStorage.setItem(k, v),
  },
  // A failed navigation reloads into its target route (with the history base), otherwise the current page.
  reload: (path) => (path ? window.location.assign(router.resolve(path).href) : window.location.reload()),
  router,
})
app.use(router)
installQuery(app)

// Default frappe-ui socket hardcodes :9000 — we use same-origin + env path instead.
app.use(FrappeUI, { socketio: false })

// Site name from env (dev) or hostname (prod). Boot may refine window.site_name later.
window.site_name = resolveSiteName()

try {
  const site = resolveSiteName()
  const socket = io(`/${site}`, {
    path: socketPath,
    withCredentials: true,
    transports: ['websocket', 'polling'],
    reconnectionAttempts: 8,
    autoConnect: true,
  })
  socket.on('connect_error', (err) => {
    if (import.meta.env.DEV) {
      console.warn('[socket]', err?.message || err)
    }
  })
  socket.on('list_update', (data) => {
    if (data?.doctype) {
      queryClient.invalidateQueries({ queryKey: ['list', data.doctype] })
    }
  })
  socket.on('doc_update', (data) => {
    if (data?.doctype && data?.name) {
      queryClient.invalidateQueries({ queryKey: ['doc', data.doctype, data.name] })
    }
  })
  window.__church_socket = socket
  app.config.globalProperties.$socket = socket
} catch (e) {
  console.warn('[socket] init failed', e)
  app.config.globalProperties.$socket = null
}

// Resolve the initial route (including the async boot/RBAC guard and any
// redirect) before mounting, so an unauthorized URL never paints the app shell
// or a previous route while the guard is still deciding.
router.isReady().finally(() => app.mount('#app'))
